import * as React from "react"
import { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from "react"
import numeral from "numeral"
import { Input, InputProps } from "../input"

export interface NumeralInputProps extends Omit<InputProps, "defaultValue"|"value"> {
  onChangeNumber?: ((value: number | null | undefined) => void) | undefined,
  defaultValue?: number | null | undefined,
  value?: number | null | undefined,
  format?: string,
  prefix?: string | undefined,
}

/**
 * Describe your component here
 */
export const NumeralInput = forwardRef(function NumeralInput(props: NumeralInputProps, ref: any) {
  const {
    onChangeNumber,
    defaultValue,
    value,
    format = '0,0.[000]',
    prefix,
    ...rest
  } = props
  const [ internalValue, setInternalValue ] = useState<number|string|null|undefined>(typeof value === 'number' ? value : defaultValue)
  const [ waitForDecimal, setWaitForDecimal ] = useState<boolean>(false)
  const [ decimalPart, setDecimalPart ] = useState<string>("")
  const initiated = useRef<boolean>(false)

  const decimalSymbol = numeral.localeData().delimiters.decimal

  useEffect(() => {
    if (!initiated.current) {
      initiated.current = true;
      return;
    }
    setInternalValue(value);
  }, [value])

  const valueFormatted = useMemo<string>(() => (
    typeof internalValue === 'number' ? `${prefix || ''}${numeral(internalValue).format(format)}${waitForDecimal ? decimalPart : ''}` : internalValue
  ), [decimalPart, format, internalValue, prefix, waitForDecimal])

  const onChangeText = useCallback((text: string) => {
    const textTemp = text.replace(/[.,]$/, decimalSymbol)
    const waitForDecimalTemp = !!(textTemp && textTemp.includes(decimalSymbol) && !numeral(textTemp.split(decimalSymbol)[1] || 0).value());
    let decimalPartTemp = "";
    if (waitForDecimalTemp) {
      decimalPartTemp = `${decimalSymbol}${(textTemp || '').split(decimalSymbol)[1]}`;
    }
    if (textTemp === '-') {
      setInternalValue(textTemp);
      return
    }
    const internalValueTemp = textTemp ? numeral(numeral(textTemp).format(format)).value() : null
    setInternalValue(internalValueTemp)
    setWaitForDecimal(waitForDecimalTemp)
    setDecimalPart(decimalPartTemp)
    onChangeNumber(internalValueTemp)
  }, [decimalSymbol, format, onChangeNumber])

  return (
    <Input
      ref={ref}
      value={valueFormatted}
      onChangeText={onChangeText}
      {...rest}
    />
  )
})
